import apiReq from 'core/api';
import type { UserActionsFilters, UserActionsListResponse } from './types';

export function buildUserActionsQuery(filters: Partial<UserActionsFilters>): string {
  const params = new URLSearchParams();
  if (filters.user_id) params.set('user_id', filters.user_id);
  if (filters.project_id) params.set('project_id', filters.project_id);
  if (filters.category) params.set('category', filters.category);
  if (filters.action) params.set('action', filters.action);
  if (filters.http_method) params.set('http_method', filters.http_method);
  if (filters.subject_type) params.set('subject_type', filters.subject_type);
  if (filters.subject_id) params.set('subject_id', filters.subject_id);
  if (filters.date_from != null) params.set('date_from', String(filters.date_from));
  if (filters.date_to != null) params.set('date_to', String(filters.date_to));
  if (filters.search) params.set('search', filters.search);
  if (filters.limit != null) params.set('limit', String(filters.limit));
  if (filters.offset != null) params.set('offset', String(filters.offset));
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export async function getUserActions(
  filters: Partial<UserActionsFilters>
): Promise<UserActionsListResponse> {
  const data = await apiReq<UserActionsListResponse>(
    `user-actions${buildUserActionsQuery(filters)}`
  );
  return data ?? { count: 0, items: [] };
}

export async function getUserActionCategories(): Promise<string[]> {
  const data = await apiReq<string[]>('user-actions/categories');
  return Array.isArray(data) ? data : [];
}

export async function getUserActionActions(category?: string | null): Promise<string[]> {
  const qs = category ? `?category=${encodeURIComponent(category)}` : '';
  const data = await apiReq<string[]>(`user-actions/actions${qs}`);
  return Array.isArray(data) ? data : [];
}
